
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import { useMediaQuery } from '@mui/material'
import TopBarDesktop from './top-bar-desktop'
import TopBarMobile from './top-bar-mobile'
import { useIsAlfaDown } from 'features/drivers'
import { connect } from 'react-redux'
import { useEnabledFeatureToggleList } from 'features/settings'

const TopBar = ( { userRoles , ...props }) => {
  const featureToggleList = useEnabledFeatureToggleList()
  const theme = useTheme()
  const isAlfaDown = useIsAlfaDown()
  const isReadonlyFeatureToggleEnabled = featureToggleList.includes('TFP2063')
  const isMilesReliabilityWarningFeatureToggleEnabled = featureToggleList.includes('TFP2548')
  const isOutOfHoursDisabledFeatureToggleEnabled = featureToggleList.includes('OutOfHoursDisabled')

  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  const milesReliabilityWarningMessage = 'TFM are aware of incorrect and unreliable odometer entries displaying in the portal. Please bear with us as we work through this issue.'

  return isSmall ? (
    <TopBarMobile
      {...props}
      showAlfaOutageMessage={isAlfaDown}
      showIsPortalReadOnlyMessage={isReadonlyFeatureToggleEnabled}
      showMilesReliabilityWarningMessage={isMilesReliabilityWarningFeatureToggleEnabled}
      milesReliabilityWarningMessage={milesReliabilityWarningMessage}
      isOutOfHoursMessageDisabled={isOutOfHoursDisabledFeatureToggleEnabled}/>
  ) : (
    <TopBarDesktop
      {...props}
      userRoles={userRoles}
      showAlfaOutageMessage={isAlfaDown}
      showIsPortalReadOnlyMessage={isReadonlyFeatureToggleEnabled}
      showMilesReliabilityWarningMessage={isMilesReliabilityWarningFeatureToggleEnabled}
      milesReliabilityWarningMessage={milesReliabilityWarningMessage}
      isOutOfHoursMessageDisabled={isOutOfHoursDisabledFeatureToggleEnabled}/>
  )
}

TopBar.propTypes = {
  notifications: PropTypes.any,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,

}

const mapStateToProps = ({ settings }) => ({
  userRoles: settings.roles,
})


export default connect(
  mapStateToProps
)(TopBar)
